import Konva from "konva";
import CustomImage from "../CustomImage";
import CustomText from "../CustomText";
import { addDebugOverlay } from "./helpers.js";
import { defaultTheme, themeColor } from "./plainObjectRenderer.js";

export function renderImage(block, crystalizedData, options) {
  const {
    x = 0,
    y = 0,
    width = 300,
    height = 200,
    fontScale = 1,
    imageCallback,
    _measureOnly,
    theme,
  } = options;
  const themeColors = theme || defaultTheme;
  const group = new Konva.Group({ x, y, width, height });
  const data = crystalizedData?.[block.id] || {};
  const src = data.src || block.src || "";
  const caption = data.caption || block.caption || "";
  const captionHeight = caption ? Math.round(28 * fontScale) : 0;
  const imageHeight = Math.max(0, height - captionHeight);

  group.add(new Konva.Rect({
    width,
    height: imageHeight,
    fill: block.background
      ? themeColor(themeColors, block.background, block.background)
      : themeColor(themeColors, "panel", "#F5F1E8"),
    cornerRadius: Math.round(4 * fontScale),
  }));

  if (!_measureOnly && src) {
    const image = new CustomImage({
      url: src,
      width,
      height: imageHeight,
      placeholder: false,
      refreshCallback: imageCallback,
    });
    group.add(image);
  }

  if (caption) {
    group.add(new CustomText({
      x: 0,
      y: imageHeight + Math.round(5 * fontScale),
      width,
      height: captionHeight,
      text: caption,
      fontSize: Math.round(10 * fontScale),
      fill: "#66736D",
      align: block.caption_alignment || "left",
      refreshCallback: imageCallback,
    }));
  }

  addDebugOverlay(group, block, options);
  return group;
}

export default renderImage;
